/**
 * US-179 / F-013 — the facility context the UI is currently showing, published
 * for `apiClient` to attach to every request as `X-Facility-Context`.
 *
 * Why a module of its own rather than reading the Zustand store directly:
 * the store holds only the MANUAL selection (`selectedFacilityId`), while the
 * value that matters is the RESOLVED one — manual selection, else current
 * shift, else backend default, else first accessible — and that resolution
 * lives in `useFacilityContext`. `apiClient` cannot import that hook, because
 * the hook imports `apiClient`; this module breaks the cycle.
 *
 * The backend treats the header as AUDIT-ONLY and never lets it widen access
 * (see backend `lib/facilityContextAudit.ts`), so a stale or wrong value here
 * mislabels an audit row at worst — it can never grant anything.
 */

/** `null` = nothing to report; `"all"` = the explicit "All facilities" choice. */
let current: string | null = null;

export function setFacilityContextSignal(value: string | null): void {
  current = value;
}

export function getFacilityContextSignal(): string | null {
  return current;
}

/** FOR TESTS — the module singleton otherwise leaks between test files. */
export function __resetFacilityContextSignalForTests(): void {
  current = null;
}
